import React, { useEffect, useState } from 'react';
import '../../styles/loginPage.css';
import '../../styles/register.css';
import { notify } from '../toast';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useNavigate, useParams } from 'react-router-dom';
import Modal from "react-modal";

const HolderEdit = () => {
    const [name, setName] = useState('');
    const [gender, setGender] = useState('');
    const [mobile, setMobile] = useState('');
    const [age, setAge] = useState('');
    const [occupation, setOccupation] = useState('');
    const [address, setAddress] = useState('');
    const [village, setVillage] = useState('');
    const [mandal, setMandal] = useState('');
    const [district, setDistrict] = useState('');
    const [pincode, setPincode] = useState('');
    const [aadhaar, setAadhaar] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const [members, setMembers] = useState([]);
    const [open, setOpen] = useState(false);
    const [memberName, setMemberName] = useState('');
    const [memberGender, setMemberGender] = useState('');
    const [memberAge, setMemberAge] = useState('');
    const [memberMobile, setMemberMobile] = useState('');
    const [memberLoading, setMemberLoading] = useState(false);

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({});

    const navigate = useNavigate();
    const { id } = useParams();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        fetchHolder();
        // eslint-disable-next-line
    }, []);

    const fetchHolder = async () => {
        try {

            const response = await axiosPrivate.get(`/holder/getHolder/${id}`);

            const data = response?.data
            setName(data?.name);
            setGender(data?.gender);
            setMobile(data?.mobile.toString());
            setAge(data?.age);
            setOccupation(data?.occupation);
            setAddress(data?.address);
            setVillage(data?.village);
            setMandal(data?.mandal);
            setDistrict(data?.district);
            setPincode(data?.pincode);
            setAadhaar(data?.aadhaar);
            setMembers(data?.members);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!validateMobile(mobile) || mobile.length !== 10) {
            return setError('Invalid mobile number');
        } else {
            try {
                setLoading(true);
                const response = await axiosPrivate.put('/holder/putHolder/' + id, {
                    name,
                    gender,
                    mobile,
                    age,
                    address,
                    occupation,
                    village,
                    district,
                    pincode,
                    mandal,
                    aadhaar
                });
                const res = response?.data;
                notify('success', res?.success);

                navigate('/');
            } catch (err) {
                const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
                notify('failed', errorMessage);
            }
            finally {
                setLoading(false);
            }
        }
        setName('');
        setGender('');
        setMobile('');
        setAge('');
        setOccupation('');
        setAddress('');
        setVillage('');
        setMandal('');
        setDistrict('');
        setPincode('');
        setAadhaar('');
        setError('');
    };

    const handleAddMember = async (e) => {
        e.preventDefault();
        try {
            setMemberLoading(true);
            const response = await axiosPrivate.post('/holder/addMember/' + id, {
                name: memberName,
                gender: memberGender,
                age: memberAge,
                mobile: memberMobile,
            });
            const res = response?.data;
            notify('success', res?.success);

            fetchHolder();

        } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
            notify('failed', errorMessage);
        }
        finally {
            setMemberLoading(false);
            setOpen(false);
            setMemberName('');
            setMemberGender('');
            setMemberAge('');
            setMemberMobile('');
        }
    }

    const handleDelete = async (memberId) => {
        try {
            const response = await axiosPrivate.delete(`/holder/deleteMember/${memberId}`);
            const res = response?.data;
            notify('success', res?.success);

            fetchHolder();

        } catch (err) {
            const errorMessage = err?.response?.data?.message || err?.message || 'error fetching server information';
            notify('failed', errorMessage);
        }
    }

    const validateMobile = (mobile) => {
        const re = /^[0-9]{10}$/;
        return re.test(mobile);
    };

    return (
        <>
            <div className='formContainer'>
                <div className='formWrapper'>
                    <h2 className='formTitle'>Holder Edit</h2>
                    {error && <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>{error}</div>}
                    <form onSubmit={handleSubmit}>

                        <div className='formRow'>
                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Name</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        autoFocus
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mobile</span>
                                    <input
                                        className='formInput'
                                        type="tel"
                                        value={mobile}
                                        onChange={(event) => setMobile(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Gender</span>
                                    <select
                                        className="formInput"
                                        name='gender'
                                        value={gender}
                                        onChange={(event) => setGender(event.target.value)}
                                        required
                                    >
                                        <option value="">select</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Age</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={age}
                                        onChange={(event) => setAge(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Occupation</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={occupation}
                                        onChange={(event) => setOccupation(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Address</span>
                                    <input
                                        className='formInput'
                                        value={address}
                                        type="text"
                                        onChange={(event) => setAddress(event.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            <div className='formGroup'>
                                <div className='formGroup'>
                                    <span className='formLabel'>Village</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={village}
                                        onChange={(event) => setVillage(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Pincode</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={pincode}
                                        onChange={(event) => setPincode(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Mandal</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={mandal}
                                        onChange={(event) => setMandal(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>District</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={district}
                                        onChange={(event) => setDistrict(event.target.value)}
                                        required
                                    />
                                </div>
                                <div className='formGroup'>
                                    <span className='formLabel'>Aadhaar</span>
                                    <input
                                        className='formInput'
                                        type="text"
                                        value={aadhaar}
                                        onChange={(event) => setAadhaar(event.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                        </div>

                        <button className='submitButton' type="submit" disabled={loading}>{loading ? <span className='spinner' /> : 'Edit'}</button>

                    </form>
                </div>
            </div>

            <div className="container">
                {// @ts-ignore
                    members?.length !== 0
                        ?
                        <><section className="user-list">
                            <div className="list-header">
                                <span>Name</span>
                                <span>Gender</span>
                                <span>Age</span>
                                <span>Mobile</span>
                                <span>Action</span>
                            </div>

                            {// @ts-ignore
                                members?.map((member) => (
                                    <div className="list-row" key={member?._id}>
                                        <span className='truncate' title={member?.name} data-label="Name">{member?.name}</span>
                                        <span className='truncate' title={member?.gender} data-label="Gender">{member?.gender}</span>
                                        <span className='truncate' title={member?.age} data-label="Age">{member?.age}</span>
                                        <span className='truncate' title={member?.mobile} data-label="Mobile">{member?.mobile}</span>
                                        <span><button className="close-btn" onClick={() => {
                                            setDeleteModalData({ subject: member?.name, delete: handleDelete, id: member?._id });
                                            setOpenDeleteModal(true);
                                        }}>Delete</button></span>
                                    </div>
                                ))
                            }

                        </section>

                            <Modal
                                isOpen={openDeleteModal}
                                onRequestClose={() => setOpenDeleteModal(false)}
                                style={{
                                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                                }}
                                className='formContainer'
                            >
                                <div className='formWrapper'>
                                    <h2 className='formTitle'>Do you want to delete&nbsp;
                                        {// @ts-ignore
                                            deleteModalData?.subject}?</h2>
                                    <div className='formRow'>
                                        <button
                                            className='close-btn'
                                            style={{ width: '95%' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setOpenDeleteModal(false);
                                                setDeleteModalData({})
                                            }}>
                                            <span>Close</span>
                                        </button>
                                        <button className="submitButton" onClick={() => {
                                            // @ts-ignore
                                            deleteModalData?.delete(deleteModalData?.id);
                                            setOpenDeleteModal(false);
                                        }}>Delete</button>
                                    </div>
                                </div>
                            </Modal >
                        </>
                        :
                        <p><i>You haven't added any members yet :(</i></p>
                }

                {
                    members?.length < 4 ?
                        <>
                            <button className='add-btn' onClick={() => setOpen(true)}>Add member</button>
                            <br />

                            <Modal
                                isOpen={open}
                                onRequestClose={() => setOpen(false)}
                                style={{
                                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                                }}
                                className='formContainer'
                            >
                                <div className='formWrapper'>
                                    <h2 className='formTitle'>Add Member</h2>
                                    <form onSubmit={handleAddMember}>

                                        <div className='formRow'>
                                            <div className='formGroup'>
                                                <span className='formLabel'>Name</span>
                                                <input
                                                    className='formInput'
                                                    type="text"
                                                    autoFocus
                                                    value={memberName}
                                                    onChange={(event) => setMemberName(event.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className='formGroup'>
                                                <span className='formLabel'>Gender</span>
                                                <select
                                                    className="formInput"
                                                    value={memberGender}
                                                    onChange={(event) => setMemberGender(event.target.value)}
                                                    required
                                                    style={{ width: "100%" }}
                                                >
                                                    <option value="">select</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className='formRow'>
                                            <div className='formGroup'>
                                                <span className='formLabel'>Age</span>
                                                <input
                                                    className='formInput'
                                                    type="text"
                                                    value={memberAge}
                                                    onChange={(event) => setMemberAge(event.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className='formGroup'>
                                                <span className='formLabel'>Mobile</span>
                                                <input
                                                    className='formInput'
                                                    type="tel"
                                                    value={memberMobile}
                                                    onChange={(event) => setMemberMobile(event.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className='formRow'>
                                            <button
                                                className='close-btn'
                                                style={{ width: '95%' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setOpen(false);
                                                }}>
                                                <span>Close</span>
                                            </button>
                                            <button
                                                className='submitButton'
                                                type="submit" disabled={loading}
                                            >
                                                {memberLoading ? <span className='spinner' /> : 'Add'}
                                            </button>
                                        </div>
                                    </form>
                                </div>

                            </Modal >
                        </>
                        :
                        <></>
                }
            </div>
        </>
    );
}

export default HolderEdit;